<template>
	<!-- Begin Page Content -->
  <div class="container-fluid" v-if="accessfree">
    <div class="row justify-content-center"  style="margin-top:30px">
      <div class="col-10">
         <div class="row">
            <div class="col-12 col-md-8"><h3 class="text-primary">Сайн байна уу? {{student.name}}</h3></div>
            <div class="col-6 col-md-4"><h3 class="text-warning font-weight-bold" style="float:right;"> </h3></div>
         </div>
      </div>
      <div>
      </div>
    </div>

    <hr/>
       <div class="row justify-content-center">
       <ul>
          <li v-for="(tab,index) in tabs" @click="_selectTab(index,tab)" class="pb-2" v-bind:class="index==selectedTab.index?'bottom-bordered':''">
              <a href="#home"><h5>{{tab.text}} </h5></a>
          </li>
        </ul>
      </div>
      <br>
    <div class="row justify-content-center" v-if="selectedTabIndex==0">
      <div class="col-10">
        <div class="card" v-if=" lessonCategories && lessonCategories.length > 0 && lessons != null && lessons.length > 0">
          <div class="card-header">
            <h5 class="text-primary font-weight-bold">Xичээлүүд</h5>
          </div>
          <div class="card-body">
            <table class="table table-bordered">
              <th class="p-0" style="width: 1%">№</th>
              <th>Name</th>
              <th class="text-center">Багш</th>
              <th class="text-center">Төрөл</th>
              <!-- <th class="text-center">Ангиар/Группээр</th> -->
              <th class="text-center">Дүн</th>
              <tr v-for="(category, index) in lessonCategories">
                <td class="py-0 text-center">{{ index + 1 }}</td>
                <td class="py-0" style="color: black; font-weight: bold">
                  {{ category.name }}
                </td>
                <td class="py-0">{{ _getTeachers(category)[0] }}</td>
                <td class="py-0 text-center">
                  <span
                    class="badge badge-success"  style="font-size:8pt" 
                    v-if="category.typeDetail.id == 'zaaval'"
                    >{{ category.typeDetail.name }}</span
                  >
                  <span class="badge badge-warning" v-else>{{
                    category.typeDetail.name
                  }}</span>
                </td>

                <td class="py-0 text-center">
                  <button class="btn btn-primary btn-sm py-0" @click="_goDetail(category)">
                    Үзэx
                     ({{category.lessons.length}})
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div v-else-if="loading == false" class="text-center alert alert-info">
          Мэдээлэл байxгүй байна!
        </div>
        <div
          v-if="loading == true"
          style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
        >
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-success" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-danger" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-info" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-dark" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="selectedTabIndex==1">
      <div class="col-10">
        <div class="card" v-if="lessonCategories&& lessonCategories.length>0&&lessons!=null && lessons.length>0">
          <div class="card-header">
            <h4 class="text-primary font-weight-bold">Улирлын дүн</h4>
          </div>
          <div class="card-body">
            <table class="table table-bordered">
              <th class="p-0" style="width:1%">№</th>
                <th>Name</th>
                <th class="text-center">Багш</th>
                <th class="text-center">Төрөл</th>
                <!-- <th class="text-center">Ангиар/Группээр</th> -->
                <th class="text-center">Дүн</th>
                <th class="text-center">Түвшин</th>
              <tr v-for="(category, index) in lessonCategories">
                <td class="text-center">{{index+1}}</td>
                <td style="color:black; font-weight:bold">{{category.name}} </td>
                <td>{{_getTeachers(category)[0]}}</td>
                <td class="text-center">
                    <span class="badge badge-success" v-if="category.typeDetail.id=='zaaval'">{{category.typeDetail.name}}</span>
                    <span class="badge badge-warning" v-else>{{category.typeDetail.name}}</span>
                </td>
                <!-- <td class="text-center">
                  {{category.index}}
                   
                </td> -->
                 <!-- <span v-if="lesson.isGroup" class="badge badge-danger">группээр</span>
                    <span v-else class="badge badge-primary">ангиар</span>      -->
                <td class="text-center"> 
                  {{_getCategoryScore(category)[0]}}
                </td>
                <td class="text-center" style="color:black; font-weight:bold">{{getXRomNumber(getXLevel(_getCategoryScore(category)[0]))}}</td>
               
              </tr>
      
            </table>
          </div>
        </div>
        <div v-else-if='loading==false' class="text-center alert alert-info">Танд одоогоор дүн байxгүй байна!</div>
        <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-success" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-danger" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-info" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-grow text-dark" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="container">
                <div class="row justify-content-center">
    <div class="card shadow-sm" style="margin-top:40px;width: 50%">
        <div class="card-body">
              <div class=" ">
                <div class="p-5">
                  <div class="text-center">
                    <h3 class="text-primary font-weight-bold">Сурагч нэвтрэх</h3>
                    <p class="text-danger">Та системд бүртгүүлэxгүй шууд дүнгээ шалгаx гэж байна. Бүртгэлтэй мэдээллээ оруулна уу!</p>
                  </div>
                  <div class="user" autocomplete="off">
                    <hr />
                    <div class="form-group">
                      <label for="exampleInputEmail1" style="font-weight:bold">Сурагчийн кодоо оруулна уу</label>
                      <input
                        autofocus
                        v-model.trim="studentCode"
                        class="form-control"
                        aria-describedby="emailHelp"
                        placeholder="Сурагчийн кодоо оруулна уу"
                      />
                    </div>
                    <div class="form-group" >
                      <label style="font-weight:bold" for="exampleInputEmail1">Регистрын дугаараа оруулна уу</label>
                      <input
                        :ref="'codeInput'"
                        v-model.trim="studentRegister"
                        class="form-control"
                        placeholder="Регистрын дугаараа оруулна уу"
                      />
                    </div>
                    <div v-if="loading==false" @click="login" class="btn btn-primary btn-block">
                      <span>Нэвтрэх</span>
                    </div>
                    <button type="button" v-else class="btn btn-primary btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex';
import myfunction from './global/myfunction.js';
import RaddarChart from './charts/RaddarChart'
import fbfunction from './global/fbfunction.js';

export default {
  name: "FinalScores",
  components: {
    RaddarChart,
  },
  data() {
    return {
      msg: "Hellow",
      tabs:[{index:0, text:'Xичээлүүд'},{index:1, text:'Улирлын дүн'}],
      selectedTabIndex: 0,
      selectedTab: null,
      lessons: [],
      trending:{
        content:[]
      },
      // school:null,
      loading: false,
      student:null,
      schoolId:null,
      lessonCategories:[],
      accessfree:false,
      studentCode:null,
      studentRegister:null,
    };
  },
  mixins:[myfunction, fbfunction],
  created() {
      //this._getInitData();
    this.selectedTabIndex=0;
    this.selectedTab = this.tabs[0];
  },
  computed: {
        ...mapState(['currentUser'])
  },
   methods: {
        _selectTab(index, tab){
          console.log(index)
          this.selectedTabIndex = index;
          this.selectedTab = this.tabs[index];
        },
        _goDetail(category) {

          if(category.lessons.length==1){
            var lesson = category.lessons[0]
            console.log(lesson);
            if(lesson && this.schoolId && lesson.id){
                let routeData = this.$router.resolve({ name: 'ShareLessonToPublicforStudent', params: { lessonId: lesson.id, schoolId: this.schoolId, sts:false} });
                window.open(routeData.href, '_blank');
            }
          }
          else{
            for(var lesson of category.lessons){
                if(lesson.finalGrade==undefined) {
                  console.log(lesson);
                  continue;
                }
                else{
                  if(lesson && lesson.school && lesson.id){
                      let routeData = this.$router.resolve({ name: 'ShareLessonToPublicforStudent', params: { lessonId: lesson.id, schoolId: lesson.school.id, sts:false} });
                      window.open(routeData.href, '_blank');
                  }
                }
              }
          }
        },
      async _getLesssons(programId) {
      await fb.db
        .collection("/schools/" + this.schoolId + "/lessons")
        .where("programIds", "array-contains",programId)
        .get()
        .then((lessonDocs) => {

          lessonDocs.forEach(async (lessonDoc) => {
            
            let lesson = lessonDoc.data();
            lesson.id = lessonDoc.id;
            // var parentLes = await lesson.category.get();
            // lesson.bgColor = parentLes.data().bgColor;
            // lesson.foreColor = parentLes.data().foreColor;

            if (lesson.category && lesson.category.id) {
              await this._findCategory(this.schoolId, lesson);
            }
            var path =
              "schools/" +
              this.schoolId +
              "/students/" +
              this.student.id +
              "/finalGrades";
            await fb.db
              .collection(path)
              .doc(lesson.id)
              .get()
              .then((docData) => {
                lesson.finalGrade = docData.data();
              });
            this.lessons.push(lesson);
          });
          this.loading = false;
        });
    },



     async login(){
       console.log(this.studentCode, this.studentRegister);
       this.loading=true;
          fb.db.collection("schools")
            .get()
            .then(querySnapshot=> {
                querySnapshot.forEach(async schoolDoc=> {
                  console.log(schoolDoc.id, schoolDoc.name);       
                   await this.loginXByCodeRegister(fb.db,schoolDoc.id, this.studentCode.toLowerCase(), this.studentRegister.toLowerCase());
                });
            })
            .catch(function(error) {
                //console.log("Error getting documents: ", error);
            });

       
       this.loading=false;
    },
    _getTeachers(category){
       var teachers = [];
       for(var lesson of category.lessons){
         if(lesson.finalGrade!=null&&lesson.finalGrade.finalScore!=null) 
          teachers.push(this.getXTeacherName(lesson));
       }
       return teachers;
     },
     _getCategoryScore(category){
       var scores = [];
       for(var lesson of category.lessons){
         if(lesson.finalGrade!=null&&lesson.finalGrade.finalScore!=null) 
          scores.push(parseInt(lesson.finalGrade.finalScore));
       }
       return scores;
     },
    
    _sortedEndCategoryDataArray: function() {
            
      function compare(a, b) {
          if (a.index < b.index)
              return -1;
          if (a.index > b.index)
              return 1;
          return 0;
      }
      return this.lessonCategories.sort(compare);
    },
    async _checkCategory(categoryDoc, lesson){
      var foundData=null;
      for(var i=0; i<this.lessonCategories.length;i++){
          var data = this.lessonCategories[i];
          if(data.id==categoryDoc.id) {
              foundData = data;
              break;
          }
      }
      if(foundData==null){
          let foundData = categoryDoc.data();
          foundData.id = categoryDoc.id;
          foundData.lessons = [];
          foundData.lessons.push(lesson);
          this.lessonCategories.push(foundData);
      }else{
          foundData.lessons.push(lesson);
      }
      return foundData;
    },
    async _findCategory(schoolId,lesson){
 
        var catRef = await fb.db.collection("schools/"+schoolId+"/categories").doc(lesson.category.id).get();
        if(catRef.exists){
            lesson.categoryTypeId = catRef.data().typeDetail.id;
            lesson.categoryTypeName = catRef.data().typeDetail.name;
            lesson.categoryData = catRef.data();
            lesson.categoryId = catRef.id;
            this._checkCategory(catRef, lesson);
            this._sortedEndCategoryDataArray();
        }
    },
     
      async _getLesssonTest(){
        await fb.db.collection('/schools/'+ this.schoolId+'/lessons').where("programIds", 'array-contains', this.student.program.id).get().then((lessonDocs)=>{
          lessonDocs.forEach(async (lessonDoc)=>{
             let lesson=lessonDoc.data();
              lesson.id=lessonDoc.id;
              // var parentLes = await lesson.category.get();
              // lesson.bgColor = parentLes.data().bgColor;
              // lesson.foreColor = parentLes.data().foreColor;

              if(lesson.category && lesson.category.id){
                  await this._findCategory(this.schoolId,lesson);
              }
              var path = "schools/"+ this.schoolId+"/students/"+ this.student.id+"/finalGrades";
              await fb.db.collection(path).doc(lesson.id).get().then(docData=>{
                  lesson.finalGrade= docData.data();
              });
              //console.log();
              this.lessons.push(lesson);
          });
        });

      },
      // async _getInitData(){
      //   var userDoc = await fb.usersCollection.doc(this.currentUser.uid).get();
      //   if(userDoc.exists&&userDoc.data().role!=null && userDoc.data().role=='student' &&userDoc.data().customer!=null){
      //     var studentDoc = await userDoc.data().customer.get();
      //     if(studentDoc.exists){
      //       this.school = studentDoc.data().school;
      //       this.schoolId = this.school.id;
      //       this.student = studentDoc.data();
      //       this.student.id = studentDoc.id;
      //       this.student.ref = studentDoc.ref;
      //     }
      //   }
      //   this.loading = true;
      //   await this._getLesssonTest();
      //   this.loading = false;
      // },
     _getScore(score){
        if(score==null) return 'Багшаасаа асууна уу';

        if(score>91) return "<span class='bg-success px-2' style='color:white'>"+score+"</span>";
        else if(score>81) return "<span class='bg-info px-2'>"+score+"</span>";
        else if(score>71) return "<span class='px-2' style='background:#a0b8ff; color:black'>"+score+"</span>";
        else if(score>61) return "<span class='px-2' style='background: #ffffd3; color:black'>"+score+"</span>";
        else return "<span class='px-2' style='background:#ffb5ae; color:black;'>"+score+"</span>";
      },
     _getColor(lesson){
        var colorText='';
        if(lesson.bgColor==undefined) {
          colorText = colorText + 'background-color:#fff;';
        }
        else {
          colorText = colorText + 'background-color:' + lesson.bgColor;
        }
        return colorText;
     },
    _getTextColor(lesson){
        var colorText='';
 
        if(lesson.foreColor==undefined) {
          colorText = colorText + 'color:#4e73df;';
        }
        else {
          colorText = colorText + 'color:' + lesson.foreColor;
        }
        return colorText;
     },
    async _getFinalGrade(lesson){
      // /schools/xUSN7smB3EcLwDYhs1Y9/students/yTy8ea67yDuyQXO8uJxI/finalGrades/7K5fdDd8BPROJgS91nAJ

   
      console.log(this.student.id);
    },
    
    goDetail(lesson){
      if(lesson && lesson.id){
        this.$router.push({ name: 'LessonDetailForStudent', params: { lessonId: lesson.id, schoolId: this.school.id, sts:false} });
      }
    }

    },
};
</script>
<style>
  .card-img-top {
      object-fit: cover!important;
      /* max-height: 165px!important; */
  }
</style>